import HistoryProcessLegal from "./HistoryProcess.vue"
export default HistoryProcessLegal